<template>
  <div v-if="recommendations.length" class="digital-lecture-detail-recommendations-list">
    <h2 class="title">{{ title }}</h2>
    <ul class="list">
      <li v-for="item in recommendations" :key="item.id" class="item">
        <NuxtLink class="item-link" :to="`/digital-lecture/${item.slug}`">
          <div class="image-wrapper">
            <img v-if="item.preview" :src="item.preview" :alt="item.name">
            <div v-if="item.time" class="time">{{ item.time }}</div>
          </div>
          <h4 class="name">{{ item.name }}</h4>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { DigitalLectureVideoCard } from '~/models/digital-lecture'

  withDefaults(
    defineProps<{
      recommendations: DigitalLectureVideoCard[]
      title?: string
    }>(),
    { title: 'Также смотрят' },
  )
</script>

<style lang="scss" scoped>
  .digital-lecture-detail-recommendations-list {
    @extend %flex-column;

    gap: 20px;
    padding: 24px;
    border-radius: 24px;
    background-color: $color-default-white;

    @include vp-767 {
      padding: 24px 16px;
    }

    > .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      margin: 0;

      @include vp-767 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .list {
      @extend %flex-column;

      gap: 24px;
      padding: 0;
      margin: 0;
      list-style: none;
    }

    > .list > .item > .item-link {
      display: flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
      color: inherit;

      > .image-wrapper {
        position: relative;
        overflow: hidden;
        width: 132px;
        min-width: 132px;
        height: 78px;
        border-radius: 6px;
        background-color: $color-potato-20;

        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        > .time {
          position: absolute;
          bottom: 10px;
          right: 10px;
          padding: 2px 8px;
          font-size: 10px;
          font-weight: 600;
          line-height: 12px;
          color: $color-kiwi-50;
          background-color: $color-potato-10;
          border-radius: 50px;
        }
      }

      > .name {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: $color-potato-90;
        margin: 0;
      }
    }
  }
</style>
